import { render, staticRenderFns } from "./Estudante-finalistas-naoTransita.vue?vue&type=template&id=06cac458&"
import script from "./Estudante-finalistas-naoTransita.vue?vue&type=script&lang=js&"
export * from "./Estudante-finalistas-naoTransita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports